import React from "react";

const FormButtom = () => {
  // console.log("pop up")
  return (
    <div
      data-bs-toggle="modal"
      data-bs-target="#exampleModalSumbit"
      className="bg-primary-blue mx-auto cursor-pointer grid w-fit place-content-center rounded-full px-5 py-2 text-center text-xl font-bold text-white"
    >
      Submit
    </div>
  );
};

export default FormButtom;
